import { useQueryCampaigns, useQueryTemplateThumbnails } from 'modules/quickActionsMenu/hooks';
import { useRumError } from 'services/observability/datadog';
import { Product, Team } from 'teams';

export const useCampaignSearch = (search = '') => {
  const addErrorSignal = useRumError();

  // Campaigns
  const { data, isLoading: isLoadingCampaigns } = useQueryCampaigns(search, {
    onError: (error) => {
      addErrorSignal(error, 'QuickActionsMenu > useCampaignSearch', {
        name: 'Quick Actions Menu campaigns GraphQL query',
        productName: Product.CAMPAIGN_INDEX,
        teamName: Team.CAMPAIGN_TEAM,
      });
    },
  });
  const { info, results = [] } = data?.campaigns || {};

  // Thumbnails
  const templateIds = results.map((campaign) => campaign.templateId);
  const { data: thumbnails = {}, isLoading: isLoadingThumbnails } = useQueryTemplateThumbnails(
    templateIds,
    {
      onError: (error) => {
        addErrorSignal(error, 'QuickActionsMenu > useQueryTemplateThumbnails', {
          name: 'Quick Actions Menu campaign template thumbnail REST query',
          productName: Product.TEMPLATE_INDEX,
          teamName: Team.CAMPAIGN_TEAM,
        });
      },
    },
  );

  return {
    campaigns: results,
    info,
    isLoading: isLoadingCampaigns || isLoadingThumbnails,
    thumbnails,
  };
};
